module.exports = __webpack_public_path__ + "static/fonts/Roboto-Regular.f36638c2.ttf";